export const isHashSearch = (text: string): boolean => {
  if (!text || typeof text !== 'string') {
    return false
  }

  const trimmed = text.trim()
  return (
    trimmed.startsWith('#') && trimmed.length > 1 && /^#[\w]+$/.test(trimmed)
  )
}
